// extracted by mini-css-extract-plugin
export var cardIcon = "_71-5";
export var checkboxCard = "_71-0";
export var checkboxCardSelected = "_71-4";
export var disabled = "_71-2";
export var interactive = "_71-1";
export var outerBorder = "_71-3";
export var spacerMedium = "_71-8";
export var spacerSmall = "_71-7";
export var spacerXsmall = "_71-6";